/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import courseDescriptionV3Style from './style';

export default function CourseDescriptionV3({my, BGImage, titles, texts} = {}) {
	let style = courseDescriptionV3Style(my);

	return (
		<div style={style.outerStyle({bg: BGImage})}>
			<div style={style.innerContainerStyle()}>
				{titles ? (
					titles.map((title, i) => {
						return (
							<h1 key={i} style={style.titleStyle()}>
								{title}
							</h1>
						);
					})
				) : (
					<></>
				)}
				{texts ? (
					texts.map((text, i) => {
						return (
							<p style={style.textStyle()} key={i}>
								{text}
							</p>
						);
					})
				) : (
					<></>
				)}
			</div>
		</div>
	);
}
